import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions } from "../../api/dtos";

export interface ITenantFormByIdRouteProps extends PropsWithChildren {
    tenantId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const TenantFormByIdRoute: FC<ITenantFormByIdRouteProps> = ({
    tenantId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const tenantIdToUse = (params.tenantId ? +params.tenantId : undefined) ?? tenantId ?? undefined;

    return (
        <ContextFormByIdProvider
            formId={tenantIdToUse}
            formDefinitionIdentifier={FormDefinitions.Tenant}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default TenantFormByIdRoute;
